import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|null} action - Optional callback function or object to execute.
 */
export const useAlert = (message, action = null) => {
  if (
    typeof window !== 'undefined' &&
    window.__aceleresPendingTransferToast &&
    /transferid/i.test(String(message || ''))
  ) {
    const targetName =
      typeof window.__aceleresPendingTransferToast === 'string'
        ? ` para ${window.__aceleresPendingTransferToast}`
        : '';
    window.__aceleresPendingTransferToast = null;
    emitter.emit('newToastMessage', {
      message: `Solicitação de transferência enviada${targetName}`,
      action,
    });
    return;
  }

  emitter.emit('newToastMessage', { message, action });
};
